import { render, staticRenderFns } from "./upAccount.vue?vue&type=template&id=ba4ed190"
import script from "./upAccount.vue?vue&type=script&lang=js"
export * from "./upAccount.vue?vue&type=script&lang=js"
import style0 from "./upAccount.vue?vue&type=style&index=0&id=ba4ed190&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4ed190')) {
      api.createRecord('ba4ed190', component.options)
    } else {
      api.reload('ba4ed190', component.options)
    }
    module.hot.accept("./upAccount.vue?vue&type=template&id=ba4ed190", function () {
      api.rerender('ba4ed190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/setCollectAccountByQuick/upAccount.vue"
export default component.exports